import { Select } from '../atoms'
import { SUPPORTED_LANGUAGES } from '../../utils/constants'
import type { SupportedLanguage } from '../../utils/constants'

export interface LanguageSelectorProps {
  currentLang: string
  onLanguageChange: (lang: SupportedLanguage) => void
}

const languageOptions = SUPPORTED_LANGUAGES.map((lang) => ({
  value: lang,
  label: lang.toUpperCase(),
}))

export const LanguageSelector = ({
  currentLang,
  onLanguageChange,
}: LanguageSelectorProps) => {
  return (
    <Select
      value={currentLang}
      onChange={(e) => onLanguageChange(e.target.value as SupportedLanguage)}
      options={languageOptions}
      aria-label="Select language"
    />
  )
}
